import { QuestionComponentHandleRef } from "@cca/components";
import { z } from "zod";

import { sortElementsByDocumentPosition } from "./dom";

export const numericParamSchema = z.coerce.number();

export const validateAndScrollToError = (
  questionComponentHandleRef: QuestionComponentHandleRef,
) => {
  const invalidComponentIds =
    questionComponentHandleRef.current?.validateResponses();

  if (!invalidComponentIds?.length) return true;

  const invalidElements = invalidComponentIds
    .map((id) => document.querySelector(`[data-answer-container="${id}"]`))
    .filter(Boolean) as HTMLElement[];
  const firstInvalidElement =
    sortElementsByDocumentPosition(invalidElements)[0];
  firstInvalidElement?.scrollIntoView({
    behavior: "smooth",
    block: "center",
  });

  return false;
};
